module.exports = "npm i hudl-uniform-ui-css --save\n"